import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faThumbsUp,
  faThumbsDown,
  faQuestionCircle,
  faHome,
  faClipboard,
  faUser,
  faHeart,
  faBell,
  faPhone,
  faCalendarAlt,
  faFilter,
  faCheckCircle,
  faCertificate,
  faMapMarkerAlt,
  faAlignJustify
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faThumbsUp);
library.add(faThumbsDown);
library.add(faQuestionCircle);
library.add(faQuestionCircle);
library.add(faHome);
library.add(faClipboard);
library.add(faHeart);
library.add(faUser);
library.add(faBell);
library.add(faPhone);
library.add(faCalendarAlt);
library.add(faFilter);
library.add(faCheckCircle);
library.add(faCertificate);
library.add(faMapMarkerAlt);
library.add(faAlignJustify);

Vue.component("font-awesome-icon", FontAwesomeIcon);
